import React, { useState } from 'react';
import './App.css';
import { UserProvider } from './context/UserContext';
import { ToastContainer } from './components/Toast';
import Home from './pages/Home/Home';
import Approve from './pages/Approve/Approve';
import Serve from './pages/Serve/Serve';
import Swap from './pages/Swap/Swap';
import Spread from './pages/Spread/Spread';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // 扫码授权落地页：/approve 路径直接渲染授权页（手机钱包内嵌浏览器打开）
  if (window.location.pathname === '/approve') {
    return <Approve />;
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'serve':
        return <Serve onTabChange={setCurrentPage} />;
      case 'swap':
        return <Swap onTabChange={setCurrentPage} />;
      case 'spread':
        return <Spread onTabChange={setCurrentPage} />;
      case 'home':
      default:
        return <Home onTabChange={setCurrentPage} />;
    }
  };

  return (
    <UserProvider>
      <div className="App">
        {renderPage()}
        <ToastContainer />
      </div>
    </UserProvider>
  );
}

export default App;
